// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2H-Or","label":"Labeled_label__3aRAb","divider":"Labeled_divider__2asY7"};